/** localStorage: visitor already finished or dismissed the NPS survey. */
export const NPS_COMPLETED_KEY = "playmath_nps_completed";

/** Fired when a game session starts (timer may begin) or last-game context updates. */
export const NPS_SESSION_CHANGED_EVENT = "playmath:npsSessionChanged";

/**
 * PostHog boolean flag controlling the ~10% NPS cohort for kids/unknown.
 * Known grownups bypass this flag (always eligible).
 */
export const NPS_SURVEY_FLAG_KEY = "nps-survey";
